import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/atkinson-hyperlegible-next';
import '@fontsource-variable/atkinson-hyperlegible-next/wght-italic.css';
import Site from './Site';
import { initializeNativeApp, isNativeApp } from './lib/native';
import './styles.css';
import './readability.css';
import './palette.css';
import './seizure-focus.css';
import './section-colors.css';
import './rescue-medications.css';
import './medication-plan.css';
import './illustrations.css';
import './modals.css';
import './mobile-navigation.css';
import './action-labels.css';

initializeNativeApp();
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode><Site /></React.StrictMode>);
if (!isNativeApp() && 'serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => { void navigator.serviceWorker.register('/sw.js').catch(() => undefined); });
}
